import { faInfo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { isNumber, roundNumber } from '../../../../../utils';
import styles from './index.module.css';

const SoilLayer = ({
    height,
    backgroundColor,
    layerHeight,
    name,
    weight,
    underWaterWeight,
    qc,
    t,
    density,
    plasticity,
    newEmbankment,
    negativeFriction,
    groundLevel,
}) => {
    const [descriptionHeight, setDescrptionHeight] = useState(0);

    const descriptionRef = (e) => {
        if (e) {
            setDescrptionHeight(e.offsetHeight);
        }
    };

    return (
        <div
            className={`${styles.layer} ${
                height === 0 ? styles.hiddenLayer : ''
            }`}
            style={{ height: `${height}px`, backgroundColor }}>
            <span className={styles.spot}>
                {layerHeight.toFixed(2)}{' '}
                {`${
                    isNumber(groundLevel)
                        ? `(${roundNumber(groundLevel - layerHeight, 2).toFixed(
                              2,
                          )})`
                        : ''
                }`}
            </span>
            <div className={styles.wrapper}>
                <div className={styles.description}>
                    <div
                        className={
                            descriptionHeight > height
                                ? styles.listWrapperHidden
                                : styles.listWrapperVisible
                        }
                        ref={descriptionRef}>
                        {name && <span className={styles.item}>{name}</span>}
                        {typeof weight === 'number' && (
                            <span className={styles.item}>
                                &#947; = {weight} kN/m<sup>3</sup>
                            </span>
                        )}
                        {typeof underWaterWeight === 'number' && (
                            <span className={styles.item}>
                                &#947;' = {underWaterWeight} kN/m<sup>3</sup>
                            </span>
                        )}
                        {typeof density === 'number' && (
                            <span className={styles.item}>Id = {density}</span>
                        )}
                        {typeof plasticity === 'number' && (
                            <span className={styles.item}>
                                Il = {plasticity}
                            </span>
                        )}
                        {typeof qc === 'number' && (
                            <span className={styles.item}>
                                q<sub>c</sub> = {qc} kPa
                            </span>
                        )}
                        {typeof t === 'number' && (
                            <span className={styles.item}>t = {t} kPa</span>
                        )}

                        {newEmbankment === true && (
                            <span className={styles.item}>Świeży nasyp NB</span>
                        )}
                        {negativeFriction === true && (
                            <span className={styles.item}>
                                Tarcie negatywne
                            </span>
                        )}
                    </div>
                    <div
                        className={`${styles.icon} ${
                            descriptionHeight <= height ? styles.iconHidden : ''
                        }`}>
                        <FontAwesomeIcon icon={faInfo} />
                        <div className={styles.details}>
                            {name && (
                                <span className={styles.item}>{name}</span>
                            )}
                            {typeof weight === 'number' && (
                                <span className={styles.item}>
                                    &#947; = {weight} kN/m<sup>3</sup>
                                </span>
                            )}
                            {typeof underWaterWeight === 'number' && (
                                <span className={styles.item}>
                                    &#947;' = {underWaterWeight} kN/m
                                    <sup>3</sup>
                                </span>
                            )}
                            {typeof density === 'number' && (
                                <span className={styles.item}>
                                    Id = {density}
                                </span>
                            )}
                            {typeof plasticity === 'number' && (
                                <span className={styles.item}>
                                    Il = {plasticity}
                                </span>
                            )}
                            {typeof qc === 'number' && (
                                <span className={styles.item}>
                                    q<sub>c</sub> = {qc} kPa
                                </span>
                            )}
                            {typeof t === 'number' && (
                                <span className={styles.item}>t = {t} kPa</span>
                            )}

                            {newEmbankment === true && (
                                <span className={styles.item}>
                                    Świeży nasyp NB
                                </span>
                            )}
                            {negativeFriction === true && (
                                <span className={styles.item}>
                                    Tarcie negatywne
                                </span>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SoilLayer;
